<template>
  <b-card title="Log">
    <app-timeline>
      <app-timeline-item
        v-for="(item, index) of timeline"
        :key="index"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>{{ item.title }}</h6>
          <small class="text-muted">{{ item.time }}</small>
        </div>
        <b-list-group>
          <b-list-group-item
            v-for="(item2, index2) of item.items"
            :key="index2"
          >
            {{ item2 }}
          </b-list-group-item>
        </b-list-group>
      </app-timeline-item>
    </app-timeline>
  </b-card>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      // timeline baru tambah diatas
      timeline: [
        {
          title: 'Version 2.0.1',
          time: '28 Februari 2024',
          items: ['Menambah akses akun super admin PUA'],
        },
        {
          title: 'Version 2.0.1',
          time: '26 Februari 2024',
          items: ['Rombak alur input ruangan'],
        },
        {
          title: 'Version 2.0.0',
          time: '13 Februari 2024',
          items: ['Inventarisasi KIB B Release'],
        },
      ],
    }
  },
}
</script>
